import { Screen, Transition } from '@goodboydigital/astro';
import { gsap } from 'gsap';
import { Container } from 'pixi.js';

export interface QuickAlphaTransitionOptions
{
    duration?: number
}

export class QuickAlphaTransition implements Transition
{
    autoManageContainers = true;
    duration: number;

    constructor(data: QuickAlphaTransitionOptions = {})
    {
        this.duration = data.duration || 0.75;
    }

    hide(_container: Container, current: Screen): Promise<void>
    {
        return new Promise((resolve) =>
        {
            // begin transiton in...

            gsap.to(current.view, { duration: this.duration * 0.3, alpha: 0, onComplete: () =>
            {
                resolve();
            } });
        });
    }

    show(_container: Container, _current: Screen, next: Screen): Promise<void>
    {
        return new Promise((resolve) =>
        {
            next.view.alpha = 0;

            gsap.to(next.view, { duration: this.duration * 0.7, alpha: 1, onComplete: () =>
            {
                resolve();
            } });
        });
    }
}
